import React from 'react';
import styles from './SideBar.module.scss';
import UserDashboardSideBarElements from 'common/components/UserDashboardSideBarElements/UserDashboardSideBarElements';
import InitialsButton from './SideBarInitialsButton';
import { Expert1 } from 'assets/user';
import { Link } from 'react-router-dom';

const SideBar = () => {
  return (
    <div className={`sidebar ${styles.sidebar}`}>
      <div className="nav-logo-wrapper">
        <Link to="/">
          <img
            className={styles.logoUnify}
            src="https://unifyapply.com/static/media/logo_unify.1892d2c8c126ae1f4ad9.png"
          />
        </Link>
        <InitialsButton />
      </div>
      <div className={`${styles.container} d-flex flex-column align-items-center`}>
        <UserDashboardSideBarElements />
        <div className={`nav-item ${styles.expertBox}`}>
          <Link to="/request-meeting" className="nav-link" aria-current="page">
            <img src={Expert1} className={styles.expertIcon} />
            <div className="d-flex flex-column">
              <p className={`m-0 ${styles.name}`}> Patricia </p>
              <p className={`m-0 ${styles.sub}`}> My expert</p>
            </div>
            <div className={`${styles.greenDot}`} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
